import type { ReactNode } from 'react';

interface GumpProps {
  title?: string;
  /** Conteúdo do cabeçalho à direita — botão de fechar, contador, etc. */
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** O painel de pergaminho com moldura. Só apresentação; não sabe nada do jogo. */
export function Gump({ title, action, className, children }: GumpProps) {
  return (
    <section className={className ? `gump ${className}` : 'gump'}>
      {title && (
        <header className="gump__head">
          <h2 className="gump__title">{title}</h2>
          {action}
        </header>
      )}
      <div className="gump__body">{children}</div>
    </section>
  );
}
